import {
  Box,
  Flex,
  Stack,
  useColorModeValue,
  Image,
  Menu,
  MenuButton,
  MenuList,
  MenuItem,
  Button,
  HStack,
  Avatar,
} from "@chakra-ui/react";
import assetImages from "../../constants/images";
import { useGetUserWorklists } from "../../api/WorklistApi";
import PayOutButton from "../PayOutButton";
import { WorklistType } from "../../types/Worklist";
import { useSignOut } from "../../api/AuthApi";
import { useGetMyActiveCodeYellows } from "../../api/CodeYellowApi";
import CodeYellowStatusLabel from "../AdminGroupsTable/CodeYellowStatusLabel.tsx";
import { HiOutlineUserCircle } from "react-icons/hi";
import NavSyncWarning from "./NavSyncWarning";
import { useGetMyGroups } from "../../api/GroupApi";

export default function NavBar() {
  const { data: worklist } = useGetUserWorklists();
  const { data: myActiveCodeYellows } = useGetMyActiveCodeYellows(1, 100);
  const { data: myGroups } = useGetMyGroups(1, 0, "admin");

  const { mutate: signOut } = useSignOut();

  const hasActivePersonalCY = myActiveCodeYellows
    ? myActiveCodeYellows.docs.filter(
        (cy) =>
          cy.worklist.type === WorklistType.PERSONAL &&
          cy.worklist.userId === worklist?.userId,
      ).length > 0
    : false;

  return (
    <Box height="100%">
      <Flex
        bg={useColorModeValue("brandBlue.800", "brandBlue.800")}
        color={useColorModeValue("gray.600", "white")}
        w="100%"
        px="1rem"
        h="100%"
        align={"center"}
      >
        <Flex flex={{ base: 2 }} justify={{ base: "start" }} mr="2">
          <Image
            src={assetImages.Logo}
            objectFit="contain"
            minW="10rem"
            align={"left"}
            h="3rem"
            alt="LnQ Logo"
          />
        </Flex>
        <Stack justifyContent="flex-end" alignItems="center" direction="row" spacing={2}>
          {myGroups?.docs?.length ? <NavSyncWarning groups={myGroups.docs} /> : null}
          <Menu>
            <MenuButton>
              <Avatar
                h="2rem"
                w="2rem"
                bg="transparent"
                icon={<HiOutlineUserCircle fontSize="2rem" />}
              />
            </MenuButton>
            <MenuList
              minW="fit-content"
              px="16px"
              borderRadius={16}
              bgColor="darkBlue2.800"
              border="none"
            >
              <MenuItem
                bgColor="darkBlue2.800"
                color="white"
                paddingY="16px"
                fontWeight="600"
              >
                <Button as="span" variant={"link"} onClick={() => signOut()} color="white">
                  Sign out
                </Button>
              </MenuItem>
            </MenuList>
          </Menu>

          <HStack spacing={2}>
            {hasActivePersonalCY && (
              <CodeYellowStatusLabel isActive={hasActivePersonalCY} isSmall />
            )}
          </HStack>

          <PayOutButton />
        </Stack>
      </Flex>
    </Box>
  );
}
